import dayjs from "dayjs"

const GRID_ROWS_PER_PAGE = 3

/** Matches breakpoints in PlansPricing.css */
function getGridColumnCount(viewportWidth = 1200) {
  if (viewportWidth >= 1400) return 4
  if (viewportWidth >= 1100) return 3
  if (viewportWidth >= 768) return 2
  return 1
}

export function getGridPageSize(viewportWidth = 1200) {
  return getGridColumnCount(viewportWidth) * GRID_ROWS_PER_PAGE
}

export function formatPlanCardLastUpdated(value) {
  if (value == null || value === "" || value === "—") return "—"
  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.format("MMM D") : String(value)
}

export function formatPlanPriceAmount(value) {
  const n = Number(value)
  if (Number.isNaN(n)) return "0"
  return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, "")
}

export function getPlanGridPriceDisplay(plan, t) {
  const price = Number(plan.price) || 0
  const discountedPrice = Number(plan.discountedPrice) || 0
  const hasYearlyDiscount =
    plan.discounted && discountedPrice > 0 && plan.type === "Subscription"

  if (plan.type === "One-Time") {
    return {
      main: `SAR ${formatPlanPriceAmount(price)}`,
      note: `(${t?.one_time_note || "Valid for one time, No renewal"})`,
    }
  }

  const isYearlyPlan = plan.billingCycle === "Yearly"
  const result = {
    main: `SAR ${formatPlanPriceAmount(price)}`,
    period: isYearlyPlan
      ? t?.billing_yearly || "/year"
      : t?.billing_monthly || "/month",
  }

  if (hasYearlyDiscount && !isYearlyPlan) {
    const amount = formatPlanPriceAmount(discountedPrice)
    result.yearlyPromo = (
      t?.yearly_promo_template || "Just SAR {amount} with yearly billing"
    ).replace("{amount}", amount)
  }

  return result
}
